import React from "react";
import { TREATMENT_STATE_INACTIVE } from "shared/src/company-tag.mjs";

export default function VirtualCareTag({ client }) {
  if (
    !(
      client?.treatments?.filter(
        (treatment) =>
          treatment.state != TREATMENT_STATE_INACTIVE &&
          treatment.virtualCareInfo.active,
      )?.length ?? 0
    ) > 0
  ) {
    return null;
  }

  return (
    <span
      style={{
        borderRadius: "50%",
        fontSize: "7px",
        color: "white",
        padding: "1px",
        backgroundColor: "#02B0FB",
        display: "inline-flex",
        fontWeight: "700",
      }}
    >
      VC
    </span>
  );
}
